import WithRender from "../../templates/base/uploadPreview.html";
import { mapGetters, mapActions } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getUploadForProductPart", "getUploadItemId"]),
    getId: function () {
      return this.getUploadItemId(this.propsData.code) + "Img";
    }
  },
  methods: {
    ...mapActions(["uploadOnPreview"]),
    getUploadedFileUniqueVersion: function () {
      return Math.floor(Math.random() * 99999);
    },
    getAttribute: function (key) {
      return this.getUploadForProductPart(this.propsData.code)[key];
    }
  },
  props: ["propsData", "useClassName"]
});
